import {AppDispatch} from '../redux/rootReducer';
import {getJsonData} from './requests';

export const getUserApplications = (dispatch: AppDispatch) => {
    const url = `api/1.0/applications`;
    return getJsonData(url, dispatch);
};
